var otherStockists = [
  {
    "lat": -38.34119248,
    "lng": 144.2993046,
    "name": "Gypsy & Co.",
    "url": "http://www.gypsyandco.com.au/",
    "address": "15 Bell Street, Torquay, 3228, Australia"
  },
  {
    "lat": 51.23095,
    "lng": -2.32295,
    "name": "Wildflower General Store",
    "url": "",
    "address": "3205 30th Avenue, Vernon, BC, BA11 1BY, Canada"
  },
  {
    "lat": -33.4651446,
    "lng": 151.4332854,
    "name": "Sweet Pea & Me",
    "url": "",
    "address": "177 Avoca Drive, Avoca Beach, 2251, Australia"
  },
  {
    "lat": 51.2442499,
    "lng": 5.12888025,
    "name": "Wild Pollen",
    "url": "http://wildpollen.com.au/",
    "address": "377 Pinchin Road, Goolmangar, 2480, Australia"
  },
  {
    "lat": 52.5371985,
    "lng": 13.41032569,
    "name": "Pretty Berlin The Store",
    "url": "http://www.prettyberlin.com/",
    "address": "31 Kastanienallee, Berlin, 10435, Germany"
  },
  {
    "lat": 46.46634026,
    "lng": 6.894014834,
    "name": "Rieder Fleurs",
    "url": "",
    "address": "26 Route du Village, Blonay, 1807, Switzerland"
  },
  {
    "lat": 51.43758075,
    "lng": 7.0093772926,
    "name": "Christiane Jepsen",
    "url": "https://twentyninepalms-essen.de/",
    "address": "Rüttenscheiderstr. 56A, Essen, 45130, Germany"
  },
  {
    "lat": 50.8554798,
    "lng": 4.2458296944,
    "name": "Jardins sur Pérolles",
    "url": "",
    "address": "29 Boulevard de Pérolles, Fribourg, 1700, Switzerland"
  },
  {
    "lat": 41.38595969,
    "lng": 2.180342474,
    "name": "The Hands",
    "url": "https://instagram.com/thehands_shop",
    "address": "Carrer de la Bòria 17 (local 3), Barcelona, 08003, Spain"
  },
  {
    "lat": 43.70034308,
    "lng": 7.286272509,
    "name": "Jahika home",
    "url": "",
    "address": "46 Rue Bonaparte, Nice, 06300, France"
  },
  {
    "lat": 49.2728879,
    "lng": -123.0654223,
    "name": "The Coast Goods Inc",
    "url": "http://thecoastgoods.ca/",
    "address": "1302 Victoria Drive, Vancouver, BC, EX4 3AN, Canada"
  },
  {
    "lat": 50.80198025,
    "lng": 8.7534373249,
    "name": "typopoetry cottage",
    "url": "",
    "address": "43 Barfüßerstraße, Marburg, 35037, Germany"
  },
  {
    "lat": 50.76801485,
    "lng": 4.348112432,
    "name": "Helo Boutique",
    "url": "",
    "address": "28 Grand-Rue, Bulle, 1630, Switzerland"
  },
  {
    "lat": 51.20534948,
    "lng": 3.210584841,
    "name": "Stera",
    "url": "http://stera.be/",
    "address": "16 Lange Vesting, Brugge, 8200, Belgium"
  },
  {
    "lat": 48.1356168,
    "lng": 11.5732955111,
    "name": "Noah and me",
    "url": "",
    "address": "10 Sendlinger Straße, München, 80331, Germany"
  },
  {
    "lat": 50.6407337,
    "lng": 3.059084953100674,
    "name": "SONIA B - Institut de beauté",
    "url": "",
    "address": "46 Rue d'Angleterre, Lille, 59800, France"
  },
  {
    "lat": 49.2347452,
    "lng": -124.7835986,
    "name": "Pinto goods and refillery",
    "url": "https://instagram.com/Pinto.goods",
    "address": "104-5405 Argyle Street, Port Alberni, BC, 36603-6400, Canada"
  },
  {
    "lat": -37.85879203,
    "lng": 144.7410653,
    "name": "Vintage Textile GmbH (FIZZEN)",
    "url": "http://www.fizzen.ch/",
    "address": "Ziegelackerstrasse 7, Bern, 3027, Switzerland"
  },
  {
    "lat": 51.44015791,
    "lng": -2.609664955,
    "name": "The botanist",
    "url": "http://www.thebotanistcalgary.com/",
    "address": "408 8 Avenue Northeast, Calgary, AB, 92024, Canada"
  },
  {
    "lat": 50.84857967,
    "lng": 5.69067981,
    "name": "Dotnsquare vintage",
    "url": "http://www.dotnsquare.nl/",
    "address": "5 Heggenstraat, Maastricht, 6211 GW, Netherlands"
  },
  {
    "lat": 47.2062257,
    "lng": 11.3941003634,
    "name": "Bürohaus Ernst Schmid GesmbH & CoKG",
    "url": "",
    "address": "2 Leopoldstraße, Innsbruck, 6020, Austria"
  },
  {
    "lat": 55.5889881667,
    "lng": 13.0099577,
    "name": "Pill & Punch",
    "url": "https://pill.se/pages/about-us",
    "address": "Claesgatan 8, Malmö, 214 26, Sweden"
  },
  {
    "lat": -35.3135495,
    "lng": 149.1402078,
    "name": "Goldfinch",
    "url": "http://www.goldfinch.store/",
    "address": "45 Jardine Street, Kingston, 2604, Australia"
  },
  {
    "lat": -19.15182586,
    "lng": 146.8506841,
    "name": "LAVA LAVA",
    "url": "",
    "address": "9 Esplanade, Picnic Bay, 4819, Australia"
  },
  {
    "lat": 28.6137517714,
    "lng": -106.0983507,
    "name": "Maiya",
    "url": "",
    "address": "128 Route de Toulouse, Noe, 31410, France"
  },
  {
    "lat": -28.143561,
    "lng": 153.471499,
    "name": "Drift Trading Co.",
    "url": "",
    "address": "5 Traders Way, Currumbin Waters, 4223, Australia"
  },
  {
    "lat": -33.9681568,
    "lng": 115.0583576,
    "name": "Marine & Co",
    "url": "",
    "address": "Shop 3 and 4 115 Bussell Highway, Margaret River, 6285, Australia"
  },
  {
    "lat": 43.48171819,
    "lng": -1.5563670780774164,
    "name": "Colors Of Surfing",
    "url": "",
    "address": "22 Avenue de Verdun, Biarritz, 64200, France"
  },
  {
    "lat": 46.80597352,
    "lng": 7.162368137,
    "name": "Librairie l'Art d'Aimer",
    "url": "",
    "address": "Rue des Epouses 5, Fribourg, 1700, Switzerland"
  },
  {
    "lat": 51.9324544,
    "lng": 4.4855,
    "name": "Komett studios",
    "url": "https://www.komettstudios.com/",
    "address": "307A Zwaanshals, Rotterdam, 3035 KJ, Netherlands"
  },
  {
    "lat": 43.13782522,
    "lng": 6.367697911028787,
    "name": "SASU PAMPA",
    "url": "",
    "address": "6 avenue du Général de Gaulle, HYERES, 83400, France"
  },
  {
    "lat": 47.23472556,
    "lng": 8.660064328,
    "name": "art333 gmbh",
    "url": "",
    "address": "Tiefenhofstrasse, Wädenswil, 8820, Switzerland"
  },
  {
    "lat": 48.8541466,
    "lng": 2.356809138,
    "name": "Fleux",
    "url": "https://www.fleux.com/",
    "address": "39 Rue Sainte-Croix de la Bretonnerie, Paris, 75004, France"
  },
  {
    "lat": 48.3532384,
    "lng": 16.3198331936,
    "name": "Stay Gold",
    "url": "http://www.staygold.store/",
    "address": "Lundenstraat, Deurne, 2100, Belgium"
  },
  {
    "lat": 44.20134573,
    "lng": -77.8843220423393,
    "name": "The GoldenLine Spiritual Studio",
    "url": "",
    "address": "25 Center Ave, Warkworth, ON, K0K 3K0, Canada"
  },
  {
    "lat": 50.5349567,
    "lng": 4.4252543405,
    "name": "edelschön",
    "url": "",
    "address": "Oberstadt, Sursee, 6210, Switzerland"
  },
  {
    "lat": 44.53992073,
    "lng": 4.746765473,
    "name": "Jiji Concept Store",
    "url": "",
    "address": "147 Route de Marseille, Montélimar, 26200, France"
  },
  {
    "lat": -34.8389257,
    "lng": 138.4828377,
    "name": "BE Home- Binding Energies",
    "url": "https://www.bindingenergies.com.au/be-home",
    "address": "49a, Semaphore, 5019, Australia"
  },
  {
    "lat": 17.90297157,
    "lng": -62.83882391,
    "name": "MUSE",
    "url": "",
    "address": "Lorient, Saint-Barthélemy, 97133, BL"
  },
  {
    "lat": 49.1839714,
    "lng": -2.1031776,
    "name": "Amelie",
    "url": "",
    "address": "22 Halkett Street, Saint Helier, JE2 4ST, JE"
  }
]